import _ from 'lodash'
import ResizeMixin from './ResizeMixin'
import ResizeBarMixin from './ResizeBarMixin'

export default {
  name: 'KHeader',
  mixins: [ResizeBarMixin, ResizeMixin],
  props: {
    height: {
      type: String,
      default: '48px',
    },
  },
  data() {
    return {
      resizeBarPlacement: 'bottom',
    }
  },
  computed: {},
  watch: {},
  methods: {},
  render() {
    const style = _.assign({
      height: this.height,
    }, this.resizeStyle)

    const css = {
      'km-header': true,
    }

    const attrs = {}

    const props = {
      style: this.style,
      color: this.type,
      lazy: true,
      size: this.size,
    }

    const events = {}

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      props: props,
      on: events,
    }

    return (
      <header {...data}>
        {this.$slots.default}
        {this.renderResizeBar()}
      </header>
    )
  },
}
